'use client';

import { useTranslation } from '@/i18n/useTranslation';

export default function WhyErtzyxSection() {
  const { t } = useTranslation();

  return (
    <section className="landing-why-section relative overflow-hidden py-20 lg:py-28">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px"
        style={{
          background: 'linear-gradient(90deg, transparent, rgba(217,164,65,0.4), transparent)',
        }}
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-10">
        <p
          className="mb-4 text-xs font-bold uppercase tracking-[0.28em]"
          style={{ color: '#d9a441' }}
        >
          {t('landing_why_ertzyx.eyebrow' as any)}
        </p>

        <h2 className="font-serif text-[clamp(1.85rem,3.4vw,2.75rem)] leading-[1.16] text-[#f4efe4]">
          {t('landing_why_ertzyx.headline' as any)}
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-[#c7d6cf] sm:text-lg sm:leading-8">
          {t('landing_why_ertzyx.body' as any)}
        </p>
      </div>
    </section>
  );
}
